import React from 'react'
import styles from './Desc.module.css'

const Desc = () => {
    return (
        <div className={styles.parent}>
            <div className={styles.flex}>
                <h1>Welcome to Air</h1>
                <p>Imagine  You starting a  <b>Company</b>  or founding  a <b>Startup</b>   and getting  a platform to <b>Present</b> your products  to the  <b>World</b>  ! What else could you hope for a building business than getting  a Stage to show Everyone your work ? That's what  <b>Air</b>  brings for you, a  <b>Platform</b>  to collaborate, exhibit, and to give the best possible start for your Company.  And all of these with  <b>Simplicity, Transparency</b> and <b>High-end Privacy</b>.

                </p>
            </div>
        </div>
    )
}

export default Desc
